module.exports = __webpack_public_path__ + "static/media/idlingDriveThru.27ff4205.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Idling/idlingDriveThru.svg
// module id = 924
// module chunks = 0